import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyBean } from '../../../beansts/company.bean';
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
declare let $: any;

@Component({
    selector : 'cellphone-modal',
    templateUrl:'cellphone-component.html'
})
export class CellphoneModalComponent implements OnInit, OnDestroy{

  public screen='main'
  public constructor( private _router : Router,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
  }
  public closeCellPhone(){
    this._appData.toggleCellPhone=false;
    this._appData.tiping=false;

  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
    this._appData.tiping=true;

  }
  public ngOnInit(): any {
  }

  public ngOnDestroy() : any {
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/cellphone-component.ts